export const ORDER_STATUS_FLOW = {
    // Define the allowed next states for each current state
    TRANSITIONS: {
        pending: {
            allowed: ["processing", "cancelled"],
            description: "NewOrderStatusDesc",
        },
        processing: {
            allowed: ["shipped", "cancelled"],
            description: "ProcessingOrderStatusDesc",
        },
        shipped: {
            allowed: ["completed"],
            description: "ShippedOrderStatusDesc",
        },
        completed: {
            allowed: [],
            description: "CompletedOrderStatusDesc",
        },
        cancelled: {
            allowed: [],
            description: "CancelledOrderStatusDesc",
        },
    },

    // Get allowed transitions for a status
    getAllowedTransitions: (currentStatus) => {
        if (!currentStatus) return []
        const status = currentStatus.toLowerCase()
        return ORDER_STATUS_FLOW.TRANSITIONS[status]?.allowed || []
    },

    // Check if a transition is valid
    isValidTransition: (fromStatus, toStatus) => {
        if (!fromStatus || !toStatus) return false
        const allowedTransitions = ORDER_STATUS_FLOW.getAllowedTransitions(fromStatus)
        return allowedTransitions.includes(toStatus.toLowerCase())
    },

    // Check if status is final (no further transitions allowed)
    isFinalStatus: (status) => {
        if (!status) return false
        const allowedTransitions = ORDER_STATUS_FLOW.getAllowedTransitions(status)
        return allowedTransitions.length === 0
    },

    // Get status description
    getStatusDescription: (status) => {
        if (!status) return ""
        const statusInfo = ORDER_STATUS_FLOW.TRANSITIONS[status.toLowerCase()]
        return statusInfo?.description || ""
    },

    // Get next possible statuses with descriptions
    getNextStatusOptions: (currentStatus) => {
        const allowed = ORDER_STATUS_FLOW.getAllowedTransitions(currentStatus)
        return allowed.map((status) => ({
            status,
            description: ORDER_STATUS_FLOW.getStatusDescription(status),
        }))
    },

    // Validate status change with reason
    validateStatusChange: (fromStatus, toStatus, reason = "") => {
        const validation = {
            isValid: false,
            message: "",
            requiresReason: false,
        }

        if (!fromStatus || !toStatus) {
            validation.message = "Invalid status parameters"
            return validation
        }

        if (fromStatus.toLowerCase() === toStatus.toLowerCase()) {
            validation.message = "Status is already set to this value"
            return validation
        }

        if (!ORDER_STATUS_FLOW.isValidTransition(fromStatus, toStatus)) {
            const allowed = ORDER_STATUS_FLOW.getAllowedTransitions(fromStatus)
            validation.message = `Cannot change from ${fromStatus} to ${toStatus}. Allowed transitions: ${allowed.join(", ")}`
            return validation
        }

        // Special validation rules
        if (toStatus.toLowerCase() === "cancelled") {
            validation.requiresReason = true
            if (!reason || reason.trim().length < 10) {
                validation.message = "CancelStatusRequiredMsg"
                return validation
            }
        }

        validation.isValid = true
        validation.message = "Status change is valid"
        return validation
    },
}

export function getAllowedOrderStatusTransitions(order) {
    if (order?.splitDeliveriesAgreed) {return [];}
    const status = order?.status?.toLowerCase();
    if (order?.courierProfileId) {
        return status === "processing" ? ["cancelled"] : [];
    }
    const allowed = ORDER_STATUS_FLOW.getAllowedTransitions(status);
    // A proposal awaiting the pharmacy's decision cannot be approved through a second UI entry point.
    return order?.awaitingConfirmation ? allowed.filter(next => next !== "processing") : allowed;
}
